import React from 'react'
import {Link} from 'react-router-dom'

import {
    NavLink,
  } from 'reactstrap';

const SignedOutLinks = () => {
    return(
    <>
      <NavLink tag={Link} to="/">You're not logged in</NavLink>
      
    </>
    )
}

export default SignedOutLinks;